import _ from 'underscore';

/**
 * @file MappingBase.js
 */
class MappingBase {

  /**
   * The Google Map object
   *
   * @type google.maps.Map
   */
  map() {
    get; set;
  }

  /**
   * A collection of all markers
   *
   * @type Array<google.maps.Marker>
   */
  allMarkers() {
    get; set;
  }

  /**
   * A collection of all info windows
   *
   * @type Array<google.maps.InfoWindow>
   */
  allInfoWindows() {
    get; set;
  }

  /**
   * A collection of all locations returned from the API
   *
   * @type Array<Object>
   */
  allLocations() {
    get; set;
  }

  /**
   * Compares based on distance
   *
   * @param a
   * @param b
   * @returns {number}
   */
  static compareByDistance(a, b) {
    if (a.Distance < b.Distance)
      return -1;
    if (a.Distance > b. Distance)
      return 1;
    return 0;
  }

  /**
   * Converts meters to miles
   *
   * @param meters
   * @returns {number}
   */
  static convertMetersToMiles(meters) {
    let _meters = parseFloat(meters);
    if (_meters !== 0) {
      return (_meters / 1609.344);
    }
    return 0;
  }

  /**
   * Retrieves a location by ID from an array of locations
   *
   * @param locationId
   * @param locationsArray
   * @returns {Object|null}
   */
  static getLocationById(locationId, locationsArray) {
    return _.find(locationsArray, function(l) {
      return parseInt(locationId) === parseInt(l.Nid);
    });
  }
}

export default MappingBase;
